
import { lazy, Suspense } from "react";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { ParentRoute, SimpleRoute } from "@/types/routes";

// Lazy load the security field guide components
const SecurityFieldGuide = lazy(() => import("@/pages/tools/security-field-guide/Index"));
const SecurityAssessment = lazy(() => import("@/pages/tools/security-field-guide/Assessment"));
const SecurityRoadmap = lazy(() => import("@/pages/tools/security-field-guide/Roadmap"));
const SecurityDashboard = lazy(() => import("@/pages/tools/security-field-guide/Dashboard"));
const SecurityResources = lazy(() => import("@/pages/tools/security-field-guide/Resources"));
const SecurityControls = lazy(() => import("@/pages/tools/security-field-guide/Controls"));
const SecurityReport = lazy(() => import("@/pages/tools/security-field-guide/Report"));
const SecurityGuideLayout = lazy(() => import("@/components/security-field-guide/SecurityGuideLayout"));

// Export as a ParentRoute object, not an array
export const toolsRoutes: ParentRoute = {
  element: (
    <Suspense fallback={<LoadingSpinner fullPage />}>
      <SecurityGuideLayout />
    </Suspense>
  ),
  children: [
    {
      path: "/tools/security-field-guide",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityFieldGuide />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/assessment",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityAssessment />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/roadmap",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityRoadmap />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/dashboard",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityDashboard />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/resources",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityResources />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/controls",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityControls />
        </Suspense>
      )
    },
    {
      path: "/tools/security-field-guide/report",
      element: (
        <Suspense fallback={<LoadingSpinner fullPage />}>
          <SecurityReport />
        </Suspense>
      )
    }
  ]
};
